import { Message } from "../../../../model/chats/GroupConversationMessageModel";

const GroupChatsProvider = new (class GroupChatsProvider {
  groupByDate = (messages: Message[]) => {
    return messages.reduce<Record<string, Message[]>>((acc, msg) => {
      const date = msg?.create_date!.toString().split(" ")[0];
      if (!acc[date]) acc[date] = [];
      //acc[date].push(msg);
      acc[date] = [msg, ...acc[date]];
      return acc;
    }, {});
  };

  checkPrevious = (messages: Message[]): Message[] => {
    let messagesLoop: Message[] = [];

    messages.forEach((msg, key) => {
      if (key === 0) {
        msg = { ...msg, same_profile: false };
      } else {
        msg = {
          ...msg,
          same_profile: messages[key - 1].account_id === msg.account_id,
        };
      }
      messagesLoop.push(msg);
    });

    return messagesLoop;
  };
})();

export default GroupChatsProvider;
